import { detect } from 'detect-browser';
import { memoize } from 'lodash';

export const suggestUpgrade = memoize(() => {
    const browser = detect();
    if (browser) {
        if (browser.type == 'browser' && browser.name == 'edge') {
            return true;
        }
    } else {
        // console.warn('Browser detection failed?!');
    }
    return false;
});
